import {CodeResponseBody, useReadCodelistQuery} from '@dms/api/core';

import {ApiError} from 'shared/web';

type CodeListIds =
  | 'interest_source'
  | 'unsuccessful_interest_reason'
  | 'unsuccessful_business_case_reason'
  | 'vehicle_source'
  | 'carPark'
  | 'cancellationReason'
  | 'rentType'
  | 'payment_preference'
  | 'workshop_interest_source'
  | 'workshop_interest_close_reason';

type CodeListReturnType = [
  CodeResponseBody[] | null,
  {isLoading: boolean; isError: boolean; error: ApiError | undefined},
];

/**
 * Loading of codelists is asynchronous.
 * Hook returns array of two items. First item is array of codes and second is loading flag.
 *
 * @param {CodeListIds} codeListId - id of codelist
 * @example
 * const [codes, {isLoading, isError, error}] = useCodeList('interest_source');
 */
export function useCodeList(codeListId: CodeListIds): CodeListReturnType {
  const {data, isLoading, isError, error} = useReadCodelistQuery({codelistId: codeListId});

  const codes = data?.codes.filter((code) => !code.isDisabled) ?? null;

  return [codes, {isLoading, isError, error}];
}
